<template>
      
      <!-- Begin page -->
      <div id="wrapper">
            
            <!-- Top Bar Start -->
            <topbar></topbar>
            <!-- Top Bar End -->
            
            
            <!-- ========== Left Sidebar Start ========== -->
            
            <!-- Left Sidebar End -->
            <left></left>
            
            
            <!-- ============================================================== -->
            <!-- Start right Content here -->
            <!-- ============================================================== -->
            <div class="content-page">
                  <!-- Start content -->
                  <div class="content">
                        <div class="container-fluid">
                        
                              <div class="row">
                                    <div class="col-12">
                                          <div class="page-title-box">
                                                <h4 class="page-title float-left">认证专区</h4>
                                                <ol class="breadcrumb float-right">
                                                      <li class="breadcrumb-item"><a href="#">cpwm</a></li>
                                                      <li class="breadcrumb-item"><a href="#">认证专区</a></li>
                                                      <li class="breadcrumb-item active">再认证</li>
                                                </ol>
                                          
                                                <div class="clearfix"></div>
                                          </div>
                                    </div>
                              </div>
                              <!-- end row -->
                              <div class="row">
                                    <div class="col-sm-12">
                                          <div class="card-box">
                                                <div class="row">
                                                      <div class="col-sm-12">
                                                            <div class="text-center mt-4">
                                                                  <h4 style="font-size: 1.5rem;font-weight: 600;">会员资格再认证申请须知</h4>
                                                                  <p class="text-muted mt-3 mb-4" style="font-size: 15px;"> 会员资格再认证（简称"再认证"）指的是按规定完成继续教育学时，在有效期到期前三个月内完成再认证申请，以延续有效的资质。</p>
                                          
                                                            </div>
                                                      </div><!-- end col -->
                                                </div><!-- end row -->
                        
                        
                                                <div class="row m-t-50">
                                                      <div class="col-sm-4">
                                                            <div class="faq-box">
                                                                  <img src="t11.png" alt="icon" class="img-responsive center-block">
                                                                  <h5 class="font-16"  >再认证的周期为2年</h5>
                                                                  <p  class="font-16p">为确保CPWM<sup>&#174;</sup>持证人能够不断地通过继续教育更新知识，每隔2年需要进行一次再认证。</p>
                                                            </div>
                                                      </div>
                                                      <!--/col-sm-4 -->
                              
                                                      <div class="col-sm-4">
                                                            <div class="faq-box">
                                                                  <img src="t7.png" alt="icon" class="img-responsive center-block">
                                                                  <h5 class="font-16"  >继续教育的方式</h5>
                                                                  <p class="font-16p">完成微信公众号《大单道》线上学习50学时或者完成指定培训机构4天（含4天）以上的面授学习。</p>
                                                            </div>
                                                      </div>
                                                      <!--/col-sm-4 -->
                              
                                                      <div class="col-sm-4">
                                                            <div class="faq-box">
                                                                  <img src="t8.png" alt="icon" class="img-responsive center-block">
                                                                  <h5 class="font-16"  >信息更新</h5>
                                                                  <p class="font-16p">信息更新非常重要，会影响CPWM<sup>&#174;</sup>持证人查询的公开信息显示内容。</p>
                                                            </div>
                                                      </div>
                                                      <!--/col-sm-4 -->
                                                </div>
                                                <!-- end row -->
                        
                                                <div class="row">
                                                      <div class="col-sm-4">
                                                            <div class="faq-box">
                                                                  <img src="t9.png" alt="icon" class="img-responsive center-block">
                                                                  <h5 class="font-16"  >提交审核</h5>
                                                                  <p class="font-16p">CPWM<sup>&#174;</sup>持证人需要自行确认并提交学时，这是判断您是否可以通过审核的重要依据。若您提交的学时总数不满足规定，申请将会被拒绝。</p>
                                                            </div>
                                                      </div>
                                                      <!--/col-sm-4 -->
                              
                                                      <div class="col-sm-4">
                                                            <div class="faq-box">
                                                                  <img src="t10.png" alt="icon" class="img-responsive center-block">
                                                                  <h5 class="font-16" >会员费支付</h5>
                                                                  <p class="font-16p">CPWM<sup>&#174;</sup>持证人通过审核后，需进行费用支付，会员费为300元/2年。</p>
                                                            </div>
                                                      </div>
                                                      <!--/col-sm-4 -->
                              
                                                      <div class="col-sm-4">
                                                            <div class="faq-box">
                                                                  <img src="t6.png" alt="icon" class="img-responsive center-block">
                                                                  <h5 class="font-16">持证人信息查询</h5>
                                                                  <p class="font-16p">完成再认证申请流程5个工作日以后，可在特许私人财富管理师（CPWM<sup>&#174;</sup>）官方网站查询更新信息。</p>
                                                            </div>
                                                      </div>
                                                      <!--/col-sm-4 -->
                                                </div>
                                                <!-- end row -->
      
                                                <div style="width: 100%;float:left;padding:40px;text-align: right;">
                                                      <a href="#/Authentication2_step1" style="color: #3662ab;font-size:15px;font-weight: 500"><img src="4.jpg" style="width: 15px;margin-right: 3px;">我已阅读并知晓，下一步</a>
                                                </div>
                                                <div style="clear: both"></div>
                  
                                          </div>
                                    </div><!-- end col -->
                              </div>
                        
                           
                              <!-- end row -->
                          
                  
                        </div> <!-- container -->
            
                  </div> <!-- content -->
      
                  <!--footer-->
      
            </div>
            
            
            <!-- ============================================================== -->
            <!-- End Right content here -->
            <!-- ============================================================== -->
      
      
      </div>
      <!-- END wrapper -->


</template>

<script>
      import topbar from './topbar';
      import left from './left';
      export default {
            name: 'signup',
            components:{topbar,left},
            data() {
                  return {
                  
                  }
            },
            mounted(){
                  this.checkpower();
            },
            methods: {
                  
                  checkpower: function () {
                       
                        this.$axios({
                              method: 'get',
                              url: '/api/member2/Authentication2_check',
                              headers: {
                                    membertoken: localStorage.getItem('membertoken')
                              }
                        }).then(function OnSuccess(response) {
                              if(response.data.code==1){
                                    
                                    window.location.href = '#/Authentication_show?key=' + response.data.msg;
                              }else if(response.data.code==2){
                                    window.location.href="#/Authentication_show?key=3";
                              }else if(response.data.code==3){
                                    window.location.href="#/Authentication_show?key=4";
                              }else if(response.data.code==4){
                                    swal(
                                          {
                                                title: response.data.msg,
                                                text: '',
                                                type: 'warning',
                                                confirmButtonColor: '#4fa7f3',
                                          }
                                    )
                              }else if(response.data.code==5){
                                    //直接跳转到填写地址那里
                                    window.location.href="#/Authentication2_step4?out_trade_no="+response.data.orderid;
                              }else if(response.data.code==6){
                                    //直接跳转到填写地址那里
                                    window.location.href="#/Authentication2_step3";
                              }
                              
                        }.bind(this)).catch(function OnError() {

                        })

                  },
                  
                  //method over

            }
            //mounted over


      }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
      .zx{width:100%;}
      .zx li{width:100%;float: left}
      .look1{width:5%;float: left}
      .look2{width: 95%;float: left}
      .tiaokuan{width:100%;border:1px dashed #333333;border-radius: 20px;padding:30px;margin:30px 0;margin-bottom: 20px;}
      .tiaokuan h2{width:100%;text-align: center;font-size:18px;}
      .tiaokuan p{width:100%;font-size:14px;line-height: 28px;}
      
      
      .font-16{font-size: 16px !important;font-weight: 500 !important;margin-bottom:.5rem}
      .font-16p{font-size: 14px;line-height: 24px;}

  
     
</style>



// WEBPACK FOOTER //
// src/components/Authentication2.vue